import axios from '../../utils/axiosConfig';

const BASE_URL = process.env.REACT_APP_LAMBDA_API_URL;

export class Contexture {
  static #token = null;
  static #profiles = null;

  static setToken(token) {
    Contexture.#token = token;
  }

  static getToken() {
    return Contexture.#token;
  }

  static setProfiles(profiles) {
    Contexture.#profiles = profiles;
  }

  static getProfiles() {
    return Contexture.#profiles;
  }

  static getHeaders(profileId = null) {
    const headers = {};

    if (Contexture.#token) {
      headers.Authorization = `Bearer ${Contexture.#token}`;
    }

    if (profileId) {
      headers['X-Contexture-Profile'] = profileId;
    }

    return headers;
  }

  static async authenticate(credentials) {
    try {
      const response = await axios.post(
        `${BASE_URL}/contexture/token`,
        credentials
      );

      const { token } = response.data;

      Contexture.setToken(token);

      return response.data;
    } catch (err) {
    }
  }
}
